<div class="text-right">
    <span *ngIf="readonly && borderless">{{ text }}</span>
</div>
<input *ngIf="!readonly || (readonly && !borderless)" nz-input [(ngModel)]="inputValue"
    [readOnly]="readonly && !borderless" class="text-right" [class.bg-grey-lighter]="readonly && !borderless"
    (ngModelChange)="onModelChanged()"
    (keydown)="onKeydown($event)" (keydown.enter)="onEnter()" (paste)="onPaste($event)" (blur)="onBlur()" (focus)="onFocus($event)" />
  